import React from 'react';
import { motion } from 'framer-motion';
export function Story() {
  return <section id="story" className="py-32 md:py-48 bg-espresso relative overflow-hidden" dir="rtl" data-id="element-142">
      <div className="container mx-auto px-6 md:px-12" data-id="element-143">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-144">
          {/* Text Content */}
          <motion.div className="w-full lg:w-1/2 flex flex-col items-start" initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1,
          ease: 'easeOut'
        }} data-id="element-145">
            <div className="flex items-center gap-4 mb-8" data-id="element-146">
              <div className="w-12 h-[1px] bg-gold" data-id="element-147" />
              <span className="font-sans text-gold text-sm tracking-widest uppercase" data-id="element-148">
                הסיפור שלנו
              </span>
            </div>

            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-cream leading-tight mb-10" data-id="element-149">
              "האוכל הוא שפה,
              <br data-id="element-150" />
              והמסעדה היא הבמה
              <br data-id="element-151" />
              עליה אנו מספרים
              <br data-id="element-152" />
              את סיפורנו."
            </h2>

            <p className="font-sans text-cream/70 text-lg leading-relaxed max-w-md" data-id="element-153">
              לוּנה נולדה מתוך תשוקה עמוקה לאירוח ולחומרי גלם מקומיים. אנו
              מאמינים שכל ארוחה היא הזדמנות ליצור זיכרון חדש, חיבור בין עבר
              להווה, בין אדמה לצלחת. המטבח שלנו שואב השראה ממסורות בישול עתיקות,
              תוך שילוב טכניקות מודרניות וגישה עכשווית.
            </p>
          </motion.div>

          {/* Image Block */}
          <motion.div className="w-full lg:w-1/2 relative" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1.2,
          ease: 'easeOut',
          delay: 0.2
        }} data-id="element-154">
            <div className="aspect-[4/5] w-full max-w-md mx-auto lg:ml-0 lg:mr-auto relative" data-id="element-155">
              <div className="absolute inset-0 bg-food-1 rounded-sm shadow-2xl overflow-hidden" data-id="element-156">
                {/* Decorative overlay to simulate texture/lighting */}
                <div className="absolute inset-0 bg-gradient-to-tr from-black/40 to-transparent mix-blend-overlay" data-id="element-157" />
                <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_center,rgba(201,168,106,0.2)_0%,transparent_100%)]" data-id="element-158" />
              </div>

              {/* Offset decorative border */}
              <div className="absolute -inset-4 border border-gold/20 rounded-sm -z-10 translate-x-4 translate-y-4" data-id="element-159" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}